import React, { useState } from 'react';
import { useAction } from 'convex/react';
import { api } from '../lib/api';

export default function TestWhatsApp() {
  const testWhatsApp = useAction(api.whatsapp.testWhatsAppMessage);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [result, setResult] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const handleTest = async () => {
    setLoading(true);
    setResult(null);
    try {
      const res = await testWhatsApp({ phoneNumber });
      setResult(res);
    } catch (error: any) {
      setResult({ error: error.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-2xl font-bold mb-6">Test WhatsApp Integration</h1>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Phone Number (with country code)
            </label>
            <input
              type="text"
              placeholder="+13108835183"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
            <p className="text-xs text-gray-500 mt-1">
              Include country code (e.g., +1 for US, +52 for Mexico)
            </p>
          </div>

          <button
            onClick={handleTest}
            disabled={loading || !phoneNumber}
            className="w-full bg-green-600 text-white py-2 px-4 rounded-md hover:bg-green-700 disabled:opacity-50"
          >
            {loading ? 'Sending...' : 'Send Test WhatsApp'}
          </button>

          {result && (
            <div className="mt-4 p-4 rounded-md bg-gray-100">
              <h3 className="font-semibold mb-2">Result:</h3>
              <pre className="text-sm overflow-x-auto">
                {JSON.stringify(result, null, 2)}
              </pre>
            </div>
          )}

          <div className="mt-6 p-4 bg-yellow-50 rounded-md">
            <h3 className="font-semibold text-yellow-800 mb-2">Setup Checklist:</h3>
            <ol className="text-sm text-yellow-700 space-y-1 list-decimal list-inside">
              <li>Set Twilio environment variables in Convex (not .env.local)</li>
              <li>Join Twilio Sandbox by sending join code to WhatsApp number</li>
              <li>Use format: +[country][number] (e.g., +13108835183)</li>
              <li>Check Convex logs for any errors</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}